module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [(!_vm.isEdit) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.userName'),
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "userName"
    },
    model: {
      value: (_vm.form.userName),
      callback: function($$v) {
        _vm.$set(_vm.form, "userName", $$v)
      },
      expression: "form.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.comfirmPass'),
      "prop": "password1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.password1),
      callback: function($$v) {
        _vm.$set(_vm.form, "password1", $$v)
      },
      expression: "form.password1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.nickName'),
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "nickName"
    },
    model: {
      value: (_vm.form.nickName),
      callback: function($$v) {
        _vm.$set(_vm.form, "nickName", $$v)
      },
      expression: "form.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.phoneNum2'),
      "prop": "phoneNum"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum"
    },
    model: {
      value: (_vm.form.phoneNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "phoneNum", $$v)
      },
      expression: "form.phoneNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_allowiplg'),
      "prop": ""
    }
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip1),
      callback: function($$v) {
        _vm.ip1 = $$v
      },
      expression: "ip1"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip2),
      callback: function($$v) {
        _vm.ip2 = $$v
      },
      expression: "ip2"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip3),
      callback: function($$v) {
        _vm.ip3 = $$v
      },
      expression: "ip3"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip4),
      callback: function($$v) {
        _vm.ip4 = $$v
      },
      expression: "ip4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "rgb(72,87,106)"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allowiptip')))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.roleName'),
      "prop": "roleid"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "id": "roleid",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.form.roleid),
      callback: function($$v) {
        _vm.$set(_vm.form, "roleid", $$v)
      },
      expression: "form.roleid"
    }
  }, _vm._l((_vm.roleList), function(item) {
    return _c('el-option', {
      key: item.roleId,
      attrs: {
        "label": item.roleName,
        "value": item.roleId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mcid),
      expression: "!mcid"
    }],
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "mechanismId"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showut),
      expression: "showut"
    }],
    attrs: {
      "label": _vm.$t('app_usertype'),
      "prop": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.userType),
      callback: function($$v) {
        _vm.$set(_vm.form, "userType", $$v)
      },
      expression: "form.userType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('app_developer')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "prop": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.userStatus),
      callback: function($$v) {
        _vm.$set(_vm.form, "userStatus", $$v)
      },
      expression: "form.userStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jh')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.dj')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add')))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.resetPass')))]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "addForm",
    staticClass: "mt20",
    attrs: {
      "id": "addForm",
      "model": _vm.formEdit,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.userName'),
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "userName"
    },
    model: {
      value: (_vm.formEdit.userName),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "userName", $$v)
      },
      expression: "formEdit.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.nickName'),
      "prop": "nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "nickName"
    },
    model: {
      value: (_vm.formEdit.nickName),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "nickName", $$v)
      },
      expression: "formEdit.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.phoneNum2'),
      "prop": "phoneNum"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "phoneNum"
    },
    model: {
      value: (_vm.formEdit.phoneNum),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "phoneNum", $$v)
      },
      expression: "formEdit.phoneNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_allowiplg'),
      "prop": ""
    }
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip1),
      callback: function($$v) {
        _vm.ip1 = $$v
      },
      expression: "ip1"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip2),
      callback: function($$v) {
        _vm.ip2 = $$v
      },
      expression: "ip2"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip3),
      callback: function($$v) {
        _vm.ip3 = $$v
      },
      expression: "ip3"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(".")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.ip4),
      callback: function($$v) {
        _vm.ip4 = $$v
      },
      expression: "ip4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "rgb(72,87,106)"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allowiptip')))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.roleName'),
      "prop": "roleid"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "id": "roleid",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formEdit.roleid),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "roleid", $$v)
      },
      expression: "formEdit.roleid"
    }
  }, _vm._l((_vm.roleList), function(item) {
    return _c('el-option', {
      key: item.roleId,
      attrs: {
        "label": item.roleName,
        "value": item.roleId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid'),
      "prop": "mechanismId"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismDataUpdate,
      "mselect": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showut),
      expression: "showut"
    }],
    attrs: {
      "label": _vm.$t('app_usertype'),
      "prop": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formEdit.userType),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "userType", $$v)
      },
      expression: "formEdit.userType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('app_developer')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "prop": "userStatus"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formEdit.userStatus),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "userStatus", $$v)
      },
      expression: "formEdit.userStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jh')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.dj')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmitEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.change')))])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.revisePass'),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('el-form', {
    ref: "formPwd",
    attrs: {
      "model": _vm.formPwd,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.newPass'),
      "label-width": _vm.formLabelWidth,
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formPwd.pass),
      callback: function($$v) {
        _vm.$set(_vm.formPwd, "pass", $$v)
      },
      expression: "formPwd.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.comfirmPass'),
      "label-width": _vm.formLabelWidth,
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formPwd.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.formPwd, "checkPass", $$v)
      },
      expression: "formPwd.checkPass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('formPwd')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.confirm')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a16ec60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/add.vue
// module id = 1083
// module chunks = 0